import { render } from "./RelatedProducts.vue?vue&type=template&id=c09bdf3e"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"

import "./RelatedProducts.vue?vue&type=style&index=0&id=c09bdf3e&lang=scss"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__